import H5 from '@base/H5/H5';
import IconButton from '@base/IconButton/IconButton';
import Image from '@base/Image';
import P2 from '@base/P2/P2';
import styled from '@emotion/styled';
import ChevronRight from '@icon/ChevronRight';
import { Fonts, Spacings } from '@styles/index';
import { FC } from 'react';

const OptionTitle = styled(H5)`
  margin-bottom: ${Spacings.SPACING_1B};
`;

const ProceedButton = styled(IconButton)`
  height: ${Spacings.SPACING_10B};
  width: ${Spacings.SPACING_10B};
  border-radius: 200px;
  background-color: transparent;
  box-shadow: none;
`;

const OptionBlock = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr 40px;
  gap: ${Spacings.SPACING_6B};
  cursor: pointer;

  &:hover {
    ${ProceedButton} {
      background: var(--color-divider);
    }
  }
`;

const Line = styled.div`
  height: 1px;
  background: var(--color-divider);
`;

const OrBlock = styled.div`
  color: var(--color-text-secondary);
  margin: ${Spacings.SPACING_9B} 0;
  text-align: center;
  display: grid;
  grid-template-columns: 1fr max-content 1fr;
  align-items: center;
  gap: ${Spacings.SPACING_4B};
  font-size: ${Fonts.EXTRA_SMALL};
`;

interface IIncludeCompletedLessonsSectionProps {
  lessonCount: number;
  handleIncludeCompletedLessons: (includeCompletedLessons: boolean) => void;
}

const IncludeCompletedLessonsSection: FC<
  IIncludeCompletedLessonsSectionProps
> = ({ lessonCount, handleIncludeCompletedLessons }) => {
  const handleOnlyPendingLessons = () => handleIncludeCompletedLessons(false);
  const handleAllLessons = () => handleIncludeCompletedLessons(true);
  return (
    <div>
      <OptionBlock onClick={handleAllLessons}>
        <Image
          src="planner/add-all-classes-in-course.svg"
          alt="Add all classes in course"
          width="48px"
          height="48px"
        />
        <div>
          <OptionTitle>Add all sessions</OptionTitle>
          <P2>We&apos;ll add all {lessonCount} sessions on planner</P2>
        </div>
        <ProceedButton>
          <ChevronRight
            size="24px"
            aria-hidden="true"
            color="var(--color-text-secondary)"
          />
        </ProceedButton>
      </OptionBlock>
      <OrBlock>
        <Line />
        OR
        <Line />
      </OrBlock>
      <OptionBlock onClick={handleOnlyPendingLessons}>
        <Image
          src="planner/add-unwatched-classes-in-course.svg"
          alt="Add unwatched classes in course"
          width="48px"
          height="48px"
        />
        <div>
          <OptionTitle>Add unwatched sessions</OptionTitle>
          <P2>We&apos;ll add unwatched sessions on planner</P2>
        </div>
        <ProceedButton>
          <ChevronRight
            size="24px"
            aria-hidden="true"
            color="var(--color-text-secondary)"
          />
        </ProceedButton>
      </OptionBlock>
    </div>
  );
};

export default IncludeCompletedLessonsSection;
